module.exports = __webpack_public_path__ + "img/why-check-img2.6e8c9430.png";